export default "__VITE_ASSET__218eddb5__"